import React, { Component } from "react";
import config from "../../config.json";
import httpService from "../../services/httpService";
import { Spinner, Accordion, Card, Tabs, Tab, Modal } from "react-bootstrap";
import authService from "../../services/authService";
import { FiRefreshCw, FiSettings } from "react-icons/fi";
import { ButtonGroup } from "react-bootstrap";
import { Button } from "react-bootstrap";
import CasovaniKlientaAktualni from "./CasovaniKlientaAktualni";

class Casovani extends Component {
  state = { filterCasovani: [] };

  componentDidMount = () => {
    this.nahrajCasovani(true);
  };

  componentWillUnmount = () => {
    if (this.reload) {
      clearTimeout(this.reload);
    }
  };

  nahrajCasovani = async (firstLoad) => {
    await this.setState({ loading: true });
    let { filterCasovani } = this.state;
    if (firstLoad) {
      filterCasovani = JSON.parse(localStorage.getItem("filterCasovani"));
      if (filterCasovani) {
        this.setState({ filterCasovani });
      }
    }
    const casovani = await httpService.post(
      config.apiEndpoint + "casovani/vypis.php",
      { filterCasovani }
    );
    this.setState({
      casovani: casovani.data.pracoviste,
      lastUpdate: casovani.data.lastUpdate,
      pracoviste: casovani.data.pracList,
      loaded: true,
      loading: false,
    });
    this.reload = setTimeout(this.nahrajCasovani, 5 * 60 * 1000);
  };

  ulozFilter = () => {
    const { filterCasovani } = this.state;
    localStorage.setItem("filterCasovani", JSON.stringify(filterCasovani));
    this.setState({ showFilter: false });
    this.nahrajCasovani();
  };

  zmenaFilter = (val) => {
    let { filterCasovani } = this.state;
    if (!filterCasovani) {
      filterCasovani = [];
    }
    if (!val.target.checked) {
      filterCasovani.push(val.target.value);
    } else {
      filterCasovani = filterCasovani.filter((f) => f !== val.target.value);
    }
    this.setState({ filterCasovani });
  };

  nastavUcast = (idpobytu, datum, cas, stav, index, index2, index3, index4) => {
    let { casovani } = this.state;
    casovani[index].den[index2].hodiny[index3].klienti[index4].stav = stav;
    httpService.post(config.apiEndpoint + "casovani/stavZmena.php", {
      idpobytu,
      datum,
      cas,
      stav,
    });
    this.setState({ casovani });
  };

  render() {
    const {
      loaded,
      loading,
      casovani,
      showFilter,
      showCasovani,
      pracoviste,
      filterCasovani,
      lastUpdate,
    } = this.state;
    const user = authService.getCurrentUser();

    if (user.casovani !== "1") {
      return <div className="alert alert-danger">Nemáte sem přístup!</div>;
    }
    return (
      <React.Fragment>
        {loaded && (
          <React.Fragment>
            <Modal
              show={showCasovani}
              onHide={() => this.setState({ showCasovani: false })}
            >
              <Modal.Header closeButton>Časování klienta</Modal.Header>
              <Modal.Body>
                {showCasovani && (
                  <CasovaniKlientaAktualni idpobytu={showCasovani} />
                )}
              </Modal.Body>
            </Modal>
            <Modal
              show={showFilter}
              onHide={() => this.setState({ showFilter: false })}
            >
              <Modal.Header closeButton>Filtr pracovišť</Modal.Header>
              <Modal.Body>
                <div className="row" style={{ fontSize: "0.8em" }}>
                  {pracoviste &&
                    pracoviste.length > 0 &&
                    pracoviste.map((p, index) => (
                      <div className="col-md-6" key={index}>
                        <input
                          type="checkbox"
                          value={p}
                          checked={
                            !(
                              filterCasovani &&
                              filterCasovani.findIndex((f) => f === p) >= 0
                            )
                          }
                          onChange={(e) => this.zmenaFilter(e)}
                        />{" "}
                        {p}
                      </div>
                    ))}
                </div>
              </Modal.Body>
              <Modal.Footer>
                <button
                  className="btn btn-outline-primary"
                  onClick={() => this.setState({ filterCasovani: pracoviste })}
                >
                  Vypnout vše
                </button>
                <button
                  className="btn btn-outline-primary"
                  onClick={() => this.setState({ filterCasovani: [] })}
                >
                  Zapnout vše
                </button>
                <button className="btn btn-primary" onClick={this.ulozFilter}>
                  Uložit
                </button>
              </Modal.Footer>
            </Modal>
            <span style={{ float: "right" }}>
              <strong>Poslední aktualizace:</strong> {lastUpdate}
            </span>
            <div className="btn-group">
              <button
                className="btn btn-outline-primary"
                style={{ marginBottom: "10px" }}
                onClick={() => this.setState({ showFilter: true })}
              >
                <FiSettings />
              </button>
              <button
                className="btn btn-outline-primary"
                style={{ marginBottom: "10px" }}
                onClick={this.nahrajCasovani}
              >
                <FiRefreshCw />
              </button>
            </div>
          </React.Fragment>
        )}
        {!loaded ? (
          loading && (
            <div className="text-warning">
              <Spinner animation="grow" size="sm" variant="warning" />
              Loading...
            </div>
          )
        ) : casovani && casovani.length > 0 ? (
          <React.Fragment>
            <Accordion>
              {casovani.map((c, index) => (
                <Card key={index}>
                  <Accordion.Toggle as={Card.Header} eventKey={index+1}>
                    {c.nazev}
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey={index+1}>
                    <Card.Body>
                      <Accordion>
                        {c.den.map((d, index2) => (
                          <Card key={"2-" + index2}>
                            <Accordion.Toggle
                              as={Card.Header}
                              eventKey={"2-" + index2}
                            >
                              {d.datum}
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey={"2-" + index2}>
                              <Card.Body>
                                {d.zalozky === true ? (
                                  <Tabs id={"tab-" + index2}>
                                    {d.hodiny.map((h, index3) => (
                                      <Tab
                                        eventKey={"3-" + index2 + "-" + index3}
                                        key={"3-" + index2 + "-" + index3}
                                        title={h.cas}
                                      >
                                        <div
                                          style={{
                                            marginTop: "12px",
                                            paddingTop: "10px",
                                            borderTop: "solid 1px #dee2e6",
                                          }}
                                          className="row"
                                        >
                                          {h.klienti.map((k, index4) => (
                                            <div
                                              className="col-md-4"
                                              key={index4}
                                              style={{ marginBottom: "20px" }}
                                            >
                                              <Card>
                                                <Card.Header>
                                                  <Button
                                                    variant="link"
                                                    style={{
                                                      padding: "0px",
                                                      margin: "0px",
                                                    }}
                                                    onClick={() =>
                                                      this.setState({
                                                        showCasovani:
                                                          k.idpobytu,
                                                      })
                                                    }
                                                  >
                                                    <span
                                                      className={
                                                        k.stav === "vcas"
                                                          ? "text-success"
                                                          : k.stav === "pozde"
                                                          ? "text-warning"
                                                          : k.stav === "vubec"
                                                          ? "text-danger"
                                                          : null
                                                      }
                                                    >
                                                      {k.klient}
                                                    </span>
                                                  </Button>
                                                </Card.Header>
                                                <Card.Body>
                                                  <div>{k.procedura}</div>
                                                  <div>{k.ubytovani}</div>
                                                  {!k.stav && (
                                                    <div className="text-center">
                                                      <small>
                                                        Klient přišel:
                                                      </small>
                                                      <div>
                                                        <ButtonGroup>
                                                          <Button
                                                            variant="success"
                                                            onClick={() => {
                                                              this.nastavUcast(
                                                                k.idpobytu,
                                                                k.den,
                                                                k.cas_od,
                                                                "vcas",
                                                                index,
                                                                index2,
                                                                index3,
                                                                index4
                                                              );
                                                            }}
                                                          >
                                                            Včas
                                                          </Button>
                                                          <Button
                                                            variant="warning"
                                                            onClick={() => {
                                                              this.nastavUcast(
                                                                k.idpobytu,
                                                                k.den,
                                                                k.cas_od,
                                                                "pozde",
                                                                index,
                                                                index2,
                                                                index3,
                                                                index4
                                                              );
                                                            }}
                                                          >
                                                            Pozdě
                                                          </Button>
                                                          <Button
                                                            variant="danger"
                                                            onClick={() => {
                                                              this.nastavUcast(
                                                                k.idpobytu,
                                                                k.den,
                                                                k.cas_od,
                                                                "vubec",
                                                                index,
                                                                index2,
                                                                index3,
                                                                index4
                                                              );
                                                            }}
                                                          >
                                                            Vůbec
                                                          </Button>
                                                        </ButtonGroup>
                                                      </div>
                                                    </div>
                                                  )}
                                                </Card.Body>
                                              </Card>
                                            </div>
                                          ))}
                                        </div>
                                      </Tab>
                                    ))}
                                  </Tabs>
                                ) : (
                                  <div className="row">
                                    {d.hodiny.map((h, index3) =>
                                      h.klienti.map((k, index4) => (
                                        <div
                                          className="col-md-4"
                                          key={index4}
                                          style={{ marginBottom: "20px" }}
                                        >
                                          <Card>
                                            <Card.Header>
                                              <span style={{ float: "right" }}>
                                                {h.cas}
                                              </span>
                                              <Button
                                                variant="link"
                                                style={{
                                                  padding: "0px",
                                                  margin: "0px",
                                                }}
                                                onClick={() =>
                                                  this.setState({
                                                    showCasovani: k.idpobytu,
                                                  })
                                                }
                                              >
                                                <span
                                                  className={
                                                    k.stav === "vcas"
                                                      ? "text-success"
                                                      : k.stav === "pozde"
                                                      ? "text-warning"
                                                      : k.stav === "vubec"
                                                      ? "text-danger"
                                                      : null
                                                  }
                                                >
                                                  {k.klient}
                                                </span>
                                              </Button>
                                            </Card.Header>
                                            <Card.Body>
                                              <div>{k.procedura}</div>
                                              <div>{k.ubytovani}</div>
                                              {!k.stav && (
                                                <div className="text-center">
                                                  <small>Klient přišel:</small>
                                                  <div>
                                                    <ButtonGroup>
                                                      <Button
                                                        variant="success"
                                                        onClick={() => {
                                                          this.nastavUcast(
                                                            k.idpobytu,
                                                            k.den,
                                                            k.cas_od,
                                                            "vcas",
                                                            index,
                                                            index2,
                                                            index3,
                                                            index4
                                                          );
                                                        }}
                                                      >
                                                        Včas
                                                      </Button>
                                                      <Button
                                                        variant="warning"
                                                        onClick={() => {
                                                          this.nastavUcast(
                                                            k.idpobytu,
                                                            k.den,
                                                            k.cas_od,
                                                            "pozde",
                                                            index,
                                                            index2,
                                                            index3,
                                                            index4
                                                          );
                                                        }}
                                                      >
                                                        Pozdě
                                                      </Button>
                                                      <Button
                                                        variant="danger"
                                                        onClick={() => {
                                                          this.nastavUcast(
                                                            k.idpobytu,
                                                            k.den,
                                                            k.cas_od,
                                                            "vubec",
                                                            index,
                                                            index2,
                                                            index3,
                                                            index4
                                                          );
                                                        }}
                                                      >
                                                        Vůbec
                                                      </Button>
                                                    </ButtonGroup>
                                                  </div>
                                                </div>
                                              )}
                                            </Card.Body>
                                          </Card>
                                        </div>
                                      ))
                                    )}
                                  </div>
                                )}
                              </Card.Body>
                            </Accordion.Collapse>
                          </Card>
                        ))}
                      </Accordion>
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
              ))}
            </Accordion>
          </React.Fragment>
        ) : (
          <div className="alert alert-danger">Nic tu není...</div>
        )}
      </React.Fragment>
    );
  }
}

export default Casovani;
